import React from 'react';

import Text from '../Text/Text';

interface IInlineDescriptionList {
  list: string[];
  separator?: string;
  className?: string;
}

const InlineDescriptionList: React.FC<IInlineDescriptionList> = ({
  list,
  separator = '•',
  className,
}) => (
  <>
    {list.map((item, index, array) => (
      <Text key={item} type="inline" className={className}>
        {item}
        {separator && index < array.length - 1 && (
          <span aria-hidden="true">&nbsp;{separator}&nbsp;</span>
        )}
      </Text>
    ))}
  </>
);

export default InlineDescriptionList;
